import "./LoaderExcel.css";

const LoaderExcel = () => {
    return (
        <div className="boxloader3">
            <div className="loader3">
                Creando
                <span></span>
            </div>
        </div>
    );
};

export default LoaderExcel;